<template>
  <div ref="inputbox">
    <draggable
      :list     = "fieldValue"
      :disabled = "disable"
      handle    = ".sr__drag-handle"
      @end      = "checkValueIsValid"
    >
      <b-form-group
        v-for = "(v, index) in fieldValue"
        :key  = "index"
        style = "margin-bottom: .25rem;"
      >
        <div class="d-flex align-items-center">
          <div
            class = "d-flex align-items-center"
            style = "width: 14%;font-weight:normal;"
          >
            <b-icon
              v-if  = "!disable"
              class = "sr__drag-handle mr-1"
              icon  = "list"
              style = "cursor: move;"
            ></b-icon>
            <span>{{`${titleAlias}${index+1}`}}.</span>
          </div>

          <!-- textarea -->
          <textarea
            lazy-formatter
            class     = "form-control sr__input"
            :class    = "{'sr__input--invalid': !valid[index]}"
            style     = "overflow-y: hidden; width: 76%;"
            @input    = "changeValue(index, $event.target.value)"
            ref       = "textareas"
            :value    = "v"
            :disabled = "disable"
          ></textarea>

          <!-- remove icon -->
          <div
            style  = "width: 10%; text-align:center"
            @click = "removeInput(index)"
            v-if   = "!disable && fieldValue.length !== 1"
          >
            <b-icon class="sr__icon sr__icon--cricle" icon="dash"></b-icon>
          </div>
        </div>

        <b-form-invalid-feedback :state="valid[index]" style="padding-left: 5%">
          {{invalidMsg[index]}}
        </b-form-invalid-feedback>

      </b-form-group>
    </draggable>

    <!-- add btn -->
    <div class="d-flex align-items-center">
      <div style="width: 90%;"></div>
      <div
        style="width: 10%; text-align:center"
        @click="addInput"
        v-if="!disable"
      >
        <b-icon class="sr__icon sr__icon--cricle" icon="plus"></b-icon>
      </div>
    </div>

  </div>
</template>

<script>
import Vue from 'vue'
import draggable from 'vuedraggable'

export default {
  name: 'InputListItem',
  props: {
    field: Object,
    disable: Boolean
  },
  data () {
    return {
      titleAlias: '',
      fieldValue: [],
      valid: [],
      invalidMsg: [],
      toValidate: true
    }
  },
  methods: {
    checkValueIsValid (uiNotify = true) {
      if (!this.toValidate) {
        return true
      }

      const invalidValue = []
      this.fieldValue.forEach((v, i) => {
        if (this._isDestroyed) {
          Vue.set(this.valid, i, true)
          Vue.set(this.invalidMsg, i, '')
          return true
        }

        if (!v) {
          if (uiNotify) {
            Vue.set(this.valid, i, false)
            Vue.set(this.invalidMsg, i, '欄位必填')
          }

          invalidValue.push(i)
        } else {
          Vue.set(this.valid, i, true)
          Vue.set(this.invalidMsg, i, '')
        }
      })

      return invalidValue.length === 0
    },
    addInput () {
      this.fieldValue.push('')
      this.invalidMsg.push('')
      this.valid.push(true)
    },
    removeInput (idx) {
      this.fieldValue.splice(idx, 1)
      this.valid.splice(idx, 1)
      this.invalidMsg.splice(idx, 1)
    },
    changeValue (idx, value) {
      this.fieldValue[idx] = value
      this.checkValueIsValid()
      this.autoTextareaHeight(idx)
    },
    autoTextareaHeight (idx) {
      this.$nextTick(() => {
        this.$refs.textareas[idx].style.height = 'auto'
        this.$refs.textareas[idx].style.height = this.$refs.textareas[idx].scrollHeight + 'px'
      })
    }
  },
  created () {
    this.titleAlias = this.field.config.title_alias || ''
    this.fieldValue = this.field.value
    this.toValidate = this.field.validates?.presence
    this.fieldValue.forEach(() => {
      this.valid.push(true)
      this.invalidMsg.push('')
    })
  },
  mounted () {
    this.$refs.textareas.forEach((e, idx) => this.autoTextareaHeight(idx))
    var top = this.$refs.inputbox.getBoundingClientRect().top

    if (this.toValidate) {
      this.$store.dispatch('pushValidateInfo', {
        id: this._uid,
        top: () => { return top },
        checkValueIsValid: this.checkValueIsValid
      })
    }
  },
  components: {
    draggable
  }
}
</script>
